export class DateHelpers {

  /// Converts a date to an ISO string in UTC format. Tries to adjust of local timezone.
  static toNormalisedUtcString(date: Date): string {
    return new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString();
  }


  /// Calculate the difference between two dates in days.
  static dateDiffInDays(date1: Date, date2: Date): number {
    const diffTime = Math.abs(date2.getTime() - date1.getTime());
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  }

}


